export const buildCollectionsRowActions = (row, permissions = {}) => {
  const actions = [];
  const canReadOnly = Boolean(permissions.readOnly);
  const canManageBilling = Boolean(permissions.billingManage);

  if (canReadOnly) {
    actions.push({
      id: row.read_only ? "read_only_off" : "read_only_on",
      label: row.read_only ? "Lift read-only" : "Read-only",
      title: row.read_only
        ? "Allow writes again for this tenant"
        : "Block writes while keeping logins active",
    });
  }

  if (canManageBilling && row.has_subscription) {
    actions.push({
      id: "cancel_subscription_period_end",
      label: "Cancel at period end",
      destructive: true,
      title: "Schedule Stripe cancellation after the current billing period",
    });
  }

  if (canManageBilling && (row.outstanding_cents ?? 0) > 0) {
    actions.push({
      id: "send_outstanding_reminder",
      label: "Email reminder",
      title: "Send payment reminder with invoice pay links and PDF attachments",
    });
  }

  return actions;
};

export const buildFollowUpRowActions = (row, permissions = {}) => {
  const actions = [];
  const canReadOnly = Boolean(permissions.readOnly);
  const canManageBilling = Boolean(permissions.billingManage);

  if (row.sectionId === "trials_expiring" && canManageBilling) {
    actions.push({
      id: "extend_trial",
      label: "Extend trial",
      title: "Push the trial end date for this tenant",
    });
  }

  if (
    (row.sectionId === "failed_payments" || row.sectionId === "overdue_collections") &&
    canReadOnly
  ) {
    actions.push({
      id: row.read_only ? "read_only_off" : "read_only_on",
      label: row.read_only ? "Lift read-only" : "Read-only",
      title: row.read_only
        ? "Allow writes again for this tenant"
        : "Block writes while keeping logins active",
    });
  }

  if (
    (row.sectionId === "failed_payments" || row.sectionId === "overdue_collections") &&
    canManageBilling &&
    row.has_subscription
  ) {
    actions.push({
      id: "cancel_subscription_period_end",
      label: "Cancel at period end",
      destructive: true,
      title: "Schedule Stripe cancellation after the current billing period",
    });
  }

  if (
    (row.sectionId === "failed_payments" || row.sectionId === "overdue_collections") &&
    canManageBilling &&
    ((row.outstanding_cents ?? 0) > 0 || (row.overdue_cents ?? 0) > 0)
  ) {
    actions.push({
      id: "send_outstanding_reminder",
      label: "Email reminder",
      title: "Send payment reminder with invoice pay links and PDF attachments",
    });
  }

  return actions;
};
